import { useRef, useState } from "react";
import { GroupAvatar } from "./ui";

// Shared name/description/avatar fields for create + edit.
export default function GroupForm({ initial, submitLabel, busy, onSubmit }) {
  const [name, setName] = useState((initial && initial.name) || "");
  const [description, setDescription] = useState((initial && initial.description) || "");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [removeImage, setRemoveImage] = useState(false);
  const fileRef = useRef(null);

  const pick = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    setFile(f);
    setRemoveImage(false);
    setPreview(URL.createObjectURL(f));
  };

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSubmit({ name: name.trim(), description: description.trim(), file, removeImage });
  };

  const currentImage = removeImage ? null : preview ? null : initial && initial.image_path;

  return (
    <form onSubmit={submit}>
      <div className="grpAvatarPick">
        {preview ? (
          <span className="grpAvatar grpAvatar-lg"><img src={preview} alt="" /></span>
        ) : (
          <GroupAvatar name={name || "گ"} image={currentImage} size="lg" />
        )}
        <div className="grpAvatarBtns">
          <button type="button" className="grpBtn grpBtn-light grpBtn-sm" onClick={() => fileRef.current.click()}>{preview || currentImage ? "عکس جدید" : "انتخاب عکس"}</button>
          {(preview || currentImage) && (
            <button type="button" className="grpBtn grpBtn-ghost grpBtn-sm" onClick={() => { setFile(null); setPreview(null); setRemoveImage(true); }}>حذف</button>
          )}
        </div>
        <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={pick} />
      </div>
      <label className="grpField">
        <span className="yekan">اسم گروه</span>
        <input className="grpInput" value={name} maxLength={80} onChange={(e) => setName(e.target.value)} placeholder="مثلا: خانواده" autoFocus />
      </label>
      <label className="grpField">
        <span className="yekan">توضیحات (اختیاری)</span>
        <textarea className="grpInput" rows={3} value={description} maxLength={300} onChange={(e) => setDescription(e.target.value)} />
      </label>
      <button type="submit" className="grpBtn grpBtn-block" disabled={busy || !name.trim()}>
        {busy ? "..." : submitLabel}
      </button>
    </form>
  );
}

export function groupFormData({ name, description, file, removeImage }) {
  const fd = new FormData();
  fd.append("name", name);
  fd.append("description", description);
  if (file) fd.append("image", file);
  if (removeImage) fd.append("remove_image", "true");
  return fd;
}
